import {
  webDeleteReq,
  webGetReq,
  webPatchReq,
  webPostReq,
} from './api';

export type Location = {
  id: number;
  name: string;
  description: string | null;
  street_address_1: string;
  street_address_2: string | null;
  city: string;
  state: string;
  postal: string;
};

// Web API (/api/web/v1), used by the Checkpoints page and Activity's location filter.

/** A safety cap on list requests. Real agencies have far fewer than this. */
export const WEB_LIST_LIMIT = 50;

export const fetchLocations = async (accessToken: string, agencyId: number | string) => {
  return webGetReq<Location[]>(
    `/agencies/${agencyId}/locations?limit=${WEB_LIST_LIMIT}`,
    accessToken
  );
};

/** What's sent to create or update a location: every field but the id. */
export type LocationFields = Omit<Location, 'id'>;

export const createLocation = async (
  accessToken: string,
  agencyId: number | string,
  location: LocationFields
) => {
  return webPostReq<Location>(`/agencies/${agencyId}/locations`, accessToken, { location });
};

export const updateLocation = async (
  accessToken: string,
  locationId: number,
  location: LocationFields
) => {
  return webPatchReq<Location>(`/locations/${locationId}`, accessToken, { location });
};

/** Also deletes the location's checkpoints. The API refuses (409) while it has partner checkpoints. */
export const deleteLocation = async (accessToken: string, locationId: number) => {
  return webDeleteReq(`/locations/${locationId}`, accessToken);
};

/** Just a checkpoint's id and name, as nested in location summaries and clearances. */
export type CheckpointSummary = {
  id: number;
  name: string;
};

/** A location with just its checkpoints' ids and names, for Activity's filters. */
export type LocationSummary = {
  id: number;
  name: string;
  checkpoints: CheckpointSummary[];
};

export const fetchLocationSummaries = async (accessToken: string, agencyId: number | string) => {
  return webGetReq<LocationSummary[]>(`/agencies/${agencyId}/locations/summaries`, accessToken);
};
